import Accordion from '../../components/Accordianitem/Accordion';
import React from 'react';
import ChiefComplaintsForm from './sunbjectcontents/ChiefComplaints';
import AllergyForm from './sunbjectcontents/Allergies';
import MedicalHistoryForm from './sunbjectcontents/MedicalHistory';
import SurgicalHistoryForm from './sunbjectcontents/SurgicalHistory';
import SocialHistoryForm from './sunbjectcontents/SocialHistory';
import MenstrualHistoryForm from './sunbjectcontents/MenstruualHistory/MenstrualHistory';
import DietForm from './sunbjectcontents/Diet';
import PastMedicationForm from './sunbjectcontents/PastMedication';
import FamilyHistory from './sunbjectcontents/FamilyHistory';
import { Sparkles } from 'lucide-react';

interface SubjectiveContentProps {
  id: string;
  gender?: "Male" | "Female" | "Other";
}

const SubjectiveContent: React.FC<SubjectiveContentProps> = ({ id, gender }) => {
  const accordionItems = [
    { title: <span className='font-jost text-lg'>Chief Complaints</span>, content: <ChiefComplaintsForm patientId={id} /> },
    { title: <span className='font-jost text-lg'>Allergies</span>, content: <AllergyForm patientId={id} /> },
    { title: <span className='font-jost text-lg'>Medical History</span>, content: <MedicalHistoryForm patientId={id} /> },
    { title: <span className='font-jost text-lg'>Surgical History</span>, content: <SurgicalHistoryForm patientId={id} /> },
    { title: <span className='font-jost text-lg'>Family History</span>, content: <FamilyHistory patientId={id} /> },
    { title: <span className='font-jost text-lg'>Social History</span>, content: <SocialHistoryForm patientId={id} /> },
    // Only add the Menstrual History item if gender is 'Female'
    ...(gender === 'Female'
      ? [{ title: <span className='font-jost text-lg'>Menstrual History</span>, content: <MenstrualHistoryForm patientId={id} /> }]
      : []),
    { title: <span className='font-jost text-lg'>Past Medication</span>, content: <PastMedicationForm patientId={id} /> },
    { title: <span className='font-jost text-lg'>Diet</span>, content: <DietForm patientId={id} /> },
  ];

  return (
    <div className="p-4 space-y-6">
      <Accordion items={accordionItems} />
    </div>
  );
};

export default SubjectiveContent;